export const CONFIRM_DIALOG_SHOW = 'CONFIRM_DIALOG_SHOW'
export const CONFIRM_DIALOG_CLOSE = 'CONFIRM_DIALOG_CLOSE'

// Action creator
export const showConfirmDialog = (title, message, onConfirm, confirmLabel = null) => {
	return { type: CONFIRM_DIALOG_SHOW, title, message, onConfirm, confirmLabel}
}
export const closeConfirmDialog = () => {
	return { type: CONFIRM_DIALOG_CLOSE}
}
